import { render } from "./ChartPageV2.vue?vue&type=template&id=e4906a28"
import script from "./ChartPageV2.vue?vue&type=script&lang=js"
export * from "./ChartPageV2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__